export const formCategoryWiseInputs = {
    "Personal Details": {
        alternateContact: {
            label: "Alternate Contact Number",
            type: "phone"
        },
        dob: {
            label: "Date Of Birth",
            type: "date"
        },
        currentResidential: {
            label: "Current Residential Address",
            type: "textarea"
        },
        permanentResidential: {
            label: "Permanent Residential Address",
            type: "textarea"
        },
        gender: {
            label: "Gender",
            type: "radio"
        },
        language: {
            label: "Language Spoken",
            type: "text"
        },
        city: {
            label: "City",
            type: "text"
        },
        pin: {
            label: "Pin Code",
            type: "text"
        },
        motherTongue: {
            label: "Mother tongue",
            type: "text"
        },
        familyMembers: {
            label: "Family Members",
            type: "text"
        },
        dependentFamilyMembers: {
            label: "Dependent Family Members",
            type: "text"
        }
    },
    "University Details": {
        universityRegistrationNumber: {
            label: "University Registration Number",
            type: "text"
        },
        universitySeatNumber: {
            label: "University Seat Number",
            type: "text"
        },
    },
    "Educational Qualification": {
        educationSpecialization: {
            label: "Education Specialization",
            type: "text"
        },
        highestQualification: {
            label: "Highest Qualification",
            type: "text"
        },
        stream: {
            label: "Stream/Specialization",
            type: "text"
        },
        collegeName: {
            label: "College Name",
            type: "text"
        },
        percentage: {
            label: "Percentage/CGPA",
            type: "text"
        },
        yearOfPassing: {
            label: "Year of Passing",
            type: "year"
        },
        twelfthPercentage: {
            label: "12th Percentage",
            type: "text"
        },
        twelfthYearOfPassing: {
            label: "12th Year of Passing",
            type: "year"
        },
        tenthPercentage: {
            label: "10th Percentage",
            type: "text"
        },
        tenthYearOfPassing: {
            label: "10th Year of Passing",
            type: "year"
        },
    },
    "Job Details": {
        candidateType: {
            label: "Candidate Type",
            type: "text"
        },
        currentLocation: {
            label: "Current Location",
            type: "text"
        },
        state: {
            label: "State",
            type: "text"
        },
        industry: {
            label: "Industry",
            type: "text"
        },
        workExperience: {
            label: "Work Experience",
            type: "text"
        },
        currentCompany: {
            label: "Current Company",
            type: "text"
        },
        workedInBank: {
            label: "Worked in Bank",
            type: "text"
        },
        verticalType: {
            label: "Vertical Applied For",
            type: "text"
        },
        yearsOfExp: {
            label: "Years of Experience",
            type: "text"
        },
        compensation: {
            label: "Expected Compensation (lpa)",
            type: "text"
        },
        locationPreference: {
            label: "Preferred locations",
            type: "text"
        },
        edpId: {
            label: "EDP Id",
            type: "text"
        },
        zoneName: {
            label: "Zone Name",
            type: "text"
        },
        site: {
            label: "Site",
            type: "text"
        },
        company: {
            label: "Last or Current Company",
            type: "text"
        },
        noticePeriod: {
            label: "Notice Period (in days)",
            type: "text"
        },
        productWorked: {
            label: "Product Worked",
            type: "text"
        },
        ticketSize: {
            label: "Ticket Size",
            type: "text"
        },
        avgIncentive: {
            label: "Average Incentive",
            type: "text"
        },
        sourceOfHiring: {
            label: "Source of Hiring",
            type: "text"
        },
        referral: {
            label: "Referral",
            type: "text"
        },
        branchDistance: {
            label: "Branch Distance",
            type: "text"
        },
    },
    "Resume": {
        resumeUpload: {
            label: "Resume",
            type: "file"
        }
    }
}
